<!-- ============================================================== -->
<!-- Banner Portal -->
<!-- ============================================================== -->
<div fxLayout="row wrap">
  <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" class="card-header">
    <mat-card class="bg-success">
      <mat-card-content>
        <!-- column -->
        <div class="d-flex no-block">
          <div class="stats">
            <h2 class="text-white m-0 card-portal">Business Intelligence - B.I.</h2>
          </div>
          <div class="stats-icon text-right ml-auto">
            <i class="fa fa-search display-5 op-5 text-white"></i>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<!-- ============================================================== -->
<!-- Slogan, Data e Ultima Atualização -->
<!-- ============================================================== -->
<div fxLayout="row wrap">
  <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card>
      <mat-card-content>
        <div class="stats">
          <div class="card-frase font-light">Bem-vindo {{ onNomeUsuario()}}</div>
          <div class="d-flex flex-row no-block">
            <div class="card-data p-10 p-l-0 b-r">
              <b>Hoje</b>
              <div class="font-light"> {{onDataHoje()}}</div>
            </div>
          </div>
        </div>
        <div class="sitec"></div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div fxLayout="row wrap">
  <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card>
      <mat-card-content>
        <div class="stats">
          <div class="card-frase font-light">AVISOS</div>
          <br>
          <div> Navegador: {{browserName}}</div>
          <br>
          <div> Versão: {{browserVersion}}</div>
          <br><br>
        </div>
        <div class="sitec"></div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<!-- Cards Módulos Home -->
<!-- ============================================================== -->
<div fxLayout="row wrap">
  <!-- Server Error -->
  <div *ngIf='isServerError' fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card>
      <mat-card-content>
        <!-- column -->
        <div class="stats">
          <div class="d-flex flex-row no-block">
            <div class="card-data p-10 p-l-0">
              <b>Instabilidade momentânea</b>
              <div class="font-light"> Alguns dados não puderam ser carregados devido a uma instabilidade momentânea,
                por favor tente novamente mais tarde.</div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<!-- ============================================================== -->
<!-- Copyright Footer -->
<!-- ============================================================== -->
<div fxLayout="row wrap">
  <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" class="card-footer">
    <mat-card>
      <mat-card-content>
        <div class="font-light">CECAM. Todos os direitos reservados. </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
